import React from "react";
import { AuthenticationProvider } from "utilities/contexts/authentication/authentication-provider";
import AuthenticatedApp from "authenticated-app";
import { useConversationGlobalState } from "utilities/atoms/conversations/use-conversation-global-state";

// At this point the settings for the app have been loaded (featureFlags, etc.)
// Let's try to log them in
const ConfiguredApp = () => {
    const { clear } = useConversationGlobalState();

    const handleLogout = () => {
        clear();
    };

    return (
        <AuthenticationProvider onLogout={handleLogout}>
            <AuthenticatedApp />
        </AuthenticationProvider>
    );
};

export default ConfiguredApp;
